import React from 'react'
import andrewMartinImg from '../../images/speakers/Andrew-Martin.jpg'

const AndrewMartinWorkshop = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
            <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="team-wrapper">
					<h3>Workshop: Advanced Kubernetes Production Debugging by Andrew Martin</h3>
                    <br />
                    <h4>Date: Thursday, 26 March</h4>
                    <h4>The Place: Wantsome, The Friendly IT Academy, Centris Building, Colonel Langa 17, Iași</h4>
                    <br />
                    <div className="row">
                        <div className="col-md-4">
                            <img src={andrewMartinImg} className="img-responsive" alt="Andrew Martin" />
                            <ul className="social-icon">
                                <li><a href="https://www.linkedin.com/in/andr3wmartin/" target="_blank" className="fa fa-linkedin wow fadeIn" data-wow-delay="0.3s"></a></li>
                                <li><a href="https://twitter.com/sublimino" target="_blank" className="fa fa-twitter wow fadeIn" data-wow-delay="0.6s"></a></li>
                            </ul>
                        </div>
                        <div className="col-md-7">
                        <p>
                        Andrew has a strong test-first engineering ethos gained architecting and deploying high-traffic web applications. <br />
                        Proficient in systems development, testing, and maintenance, he is comfortable profiling and securing every tier of a bare metal or cloud native application, and has battle-hardened experience delivering containerised solutions to enterprise clients. He is a co-founder at <a href="https://control-plane.io" target="_blank">ControlPlane.io</a>
                        </p>
                        </div>
                    </div>
                    <div className="row">
                        <h4>Schedule</h4>
                        <p>
                            <br />
                            08:30 - 09:00 - Registration<br />
                            09:00 - 13:00 -  Workshop<br />
                            13:00 - 14:00 - Lunch<br />
                            14:00 - 18:00 - Workshop<br />
                            <br />
                        </p>
                        <h4>About the workshop</h4>
                        <p>
                        Debug broken Kubernetes clusters and application failures. Compete to resolve the production outage first! This entertaining and frenetic workshop is designed to provide the kind of experience engineers only get when production goes down. Previous experience with Kubernetes is required.
                        <br /><br />
                        In this workshop you will be presented with various broken Kubernetes cluster scenarios as well as application failure scenarios. You will be split into teams of varying levels of experience and compete over who can resolve the production outage first.
                        <br /><br />
                        Emphasis is on collaboration and communication, which are key to getting through any outage as a team. Previous experience with Kubernetes is required.
                        <br /><br />                        
                        </p>
                        <br />
                        <h4>Prerequisites</h4>
                        <p> 
                        This workshop can be dynamically customised to attendee skills, includes presentations on Kubernetes debugging, hardening, and maintenance, and is entirely hosted. Attendees should bring a laptop and a willingness to participate.
                        </p>
                    </div>                                        
                    <div className="content row" id="tickets">
                        <div className="plans">
                            <div className="plan">
                                <h2 className="plan-title">Workshop <br />Early bird</h2>
                                <ul className="plan-features">
                                    <li><strong>9 December - 19 January</strong></li>
                                </ul>
                                <p className="plan-price">€350</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets disabled" href="#" target="_blank"> Sold out </a>
                            </div>
                            <div className="plan plan-tall">
                                <h2 className="plan-title">Workshop <br />Normal</h2>
                                <ul className="plan-features">
                                    <li><strong>20 January - 8 March</strong></li>
                                </ul>
                                <p className="plan-price">€400</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets" href="https://forms.gle/QUouQAUX5LvEi9r89" target="_blank"> Register </a>
                            </div>
                            <div className="plan">
                                <h2 className="plan-title">Workshop <br />Late bird</h2>
                                <ul className="plan-features">
                                    <li><strong>8 March - 25 March</strong></li>
                                </ul>
                                <p className="plan-price">€450</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets disabled" href="#" target="_blank"> Not available </a>
                            </div>
                        </div>	
                    </div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default AndrewMartinWorkshop


// WEBPACK FOOTER //
// ./src/pages/workshops/advanced-kubernetes-debugging.js